import axios from 'axios';

export const downloadBlobFile = (filename, blob) => {
  // see: https://stackoverflow.com/questions/19327749/javascript-blob-filename-without-link

  // get downloadable url from the blob
  const blobUrl = URL.createObjectURL(blob);

  // create temp link element
  let link = document.createElement('a');
  link.download = filename;
  link.href = blobUrl;

  // use the link to invoke a download
  document.body.appendChild(link);
  link.click();

  // remove the link
  setTimeout(() => {
    link.remove();
    window.URL.revokeObjectURL(blobUrl);
    link = null;
  }, 0);
};

export const isURL = (imageSrc) => {
  const urlPattern = /^(http|https|ftp):\/\//;
  return urlPattern.test(imageSrc);
};

export const arrayBufferToBase64 = (buffer) => {
  const binary = String.fromCharCode(...new Uint8Array(buffer));

  return btoa(binary);
};

export const convertImageUrlToBase64 = async (imageUrl) => {
  const response = await axios.get(imageUrl, { responseType: 'arraybuffer' });
  if (response.status !== 200) {
    throw new Error('Image fetch failed');
  }
  const arrayBuffer = await response.data;
  const base64String = arrayBufferToBase64(arrayBuffer);
  return base64String;
};

export const isBase64Image = (imageLink) => imageLink && imageLink.startsWith('data:image');
// Get base64 image from url or embedded base64 image
export const getBase64Image = async (imageLink) => {
  try {
    // Check if the imageLink is already in base64 format
    if (isBase64Image(imageLink)) {
      return imageLink; // Already base64, return as is
    }

    // Fetch and convert to base64 if it's a URL
    const response = await fetch(imageLink);
    if (!response.ok) {
      console.error(`Failed to fetch image: ${response.statusText}`);
      // throw new Error(`Failed to fetch image: ${response.statusText}`);
      return null;
    }

    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(new Error(`FileReader error: ${error.message}`));
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error(`Error converting image to Base64: ${error.message}`);
    // Optionally return a fallback value or null
    return null;
  }
};

export const mimeToExtension = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'image/gif': 'gif',
  'image/jpeg': 'jpg', // or 'jpeg' if you prefer
  'image/png': 'png',
  'image/tiff': 'tiff', // or 'tif'
  'image/heic': 'heic',
  'text/csv': 'csv',
  'application/pdf': 'pdf',
  'text/plain': 'txt',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
};

export const getFileExtensionFromBase64 = (base64String) => {
  try {
    // Extract the MIME type from the base64 string
    const mimeTypeMatch = base64String.match(/^data:(.*?);base64/);

    if (!mimeTypeMatch || !mimeTypeMatch[1]) {
      return 'bin'; // if mime type not extracted from base64
    }

    const mimeType = mimeTypeMatch[1];

    // Return the corresponding file extension
    return mimeToExtension[mimeType] || 'bin';
  } catch (error) {
    return 'bin';
  } // Default to 'bin' if MIME type is unknown
};

export const blobToBase64 = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    resolve(reader.result);
  };
  reader.onerror = reject;
  reader.readAsDataURL(blob);
});
